<script>
    import {actionsStore, actionsPopupStore, submitAction, closeActionPopup} from "./actions-store.js";
    import { t } from '../../core/i18n/language-store';

    function clickHandler(action) {
        submitAction(action);
    }

    function closeHandler() {
        closeActionPopup();
    }
</script>

<style>

    .actions-popup-container {
        width: 100%;
        padding: 1rem;
    }
    .actions-popup-container .title {
        color: var(--main-font-color);
        font-weight: 600;
        gap: 4px;
    }
    .actions-popup-container ul {
        margin-bottom: .5rem;
    }

    .actions-popup-container .popup-content {
        background: var(--actions-popup-bg);
    }
    .action-item {
        color: var(--main-font-color);
        border-bottom: var(--action-item-div);
        padding: 10px 0;
        transition: opacity .2s ease;
    }
    .action-item--active {
        opacity: 0.5;
    }
    .action {}
    .action-name {
        font-weight: 400;
        color: var(--action-name);
    }
    .action-desc {
        font-weight: 300;
        color: var(--action-desc);
        letter-spacing: .25px;
        line-height: 1.2;
    }
    .close-action-popup {
        background: var(--price-item-bg-color);
        color: #FFFFFF;
        border: none;
        padding: 10px;
        border-radius: var(--border-radius-xxs);
        font: inherit;
        font-weight: 400;
    }
    .plr-05 {
        padding: 0 .5rem;
    }

    @media (min-width: 768px) {
        .actions-popup-container .popup-content {
            min-width: 300px;
            max-width: 40vw;
        }
    }

    .hide-wo-table,
    .hide-wo-table.hide-on-desktop,
    .hide-wo-table.hide-on-mobile {
        display: none !important;
    }
    .hide-on-desktop {
        display: none !important;
    }
    .hide-on-mobile {
        display: inherit;
    }

    @media (max-width: 767px) {
        .hide-on-mobile {
            display: none !important;
        }
        .hide-on-desktop {
            display: inherit !important;
        }
    }

</style>

{#if ($actionsPopupStore.opened) }

<div class="layer-widgets screen-backdrop fade-in-animation" class:fade-out={$actionsPopupStore.closing} on:click={() => closeHandler() }></div>

<div class="layer-widgets stick-bottom full-width">

    <div class="actions-popup-container fade-in-animation slide-up-animation flex jc-center ai-center" on:click={() => closeHandler() }>
        <div class="popup-content can-fade-out"
             class:popup-content--closing={$actionsPopupStore.closing}
             class:fade-out={$actionsPopupStore.closing}
             on:click|stopPropagation={() => {}}>

            <div class="title flex ai-center">
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.75 12H12.375V6.6875C12.375 4.48281 10.7453 2.66094 8.625 2.35781V1.75C8.625 1.40469 8.34531 1.125 8 1.125C7.65469 1.125 7.375 1.40469 7.375 1.75V2.35781C5.25469 2.66094 3.625 4.48281 3.625 6.6875V12H3.25C2.97344 12 2.75 12.2234 2.75 12.5V13C2.75 13.0688 2.80625 13.125 2.875 13.125H6.25C6.25 14.0906 7.03438 14.875 8 14.875C8.96562 14.875 9.75 14.0906 9.75 13.125H13.125C13.1938 13.125 13.25 13.0688 13.25 13V12.5C13.25 12.2234 13.0266 12 12.75 12ZM8 13.875C7.58594 13.875 7.25 13.5391 7.25 13.125H8.75C8.75 13.5391 8.41406 13.875 8 13.875ZM4.75 12V6.6875C4.75 5.81875 5.0875 5.00312 5.70156 4.38906C6.31562 3.775 7.13125 3.4375 8 3.4375C8.86875 3.4375 9.68437 3.775 10.2984 4.38906C10.9125 5.00312 11.25 5.81875 11.25 6.6875V12H4.75Z" fill="currentColor"/>
                </svg>
                <span>
                    {$t('actions.popupTitle')}
                </span>
            </div>

            <ul>

                {#each $actionsStore.actions as action }
                <li class="action-item"
                    class:hide-wo-table={ action.hideWithoutTable }
                    class:hide-on-mobile={ action.hideOnMobile }
                    class:hide-on-desktop={ action.hideOnDesktop }
                    class:action-item--active={$actionsPopupStore.submittingActionId === action.id}
                    on:click={() => clickHandler(action)}>
                    <div class="flex-between ai-center">
                        <div class="action">
                            <div class="action-name fs-100">{ action.label }</div>
                            {#if action.description }
                            <div class="action-desc fs-85">{ action.description }</div>
                            {/if}
                        </div>
                        <div class="plr-05">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 10.01C0.434424 10.0108 0.369407 9.99787 0.309129 9.97203C0.248851 9.9462 0.194646 9.90804 0.15 9.86C-0.05 9.66 -0.05 9.35 0.15 9.15L4.3 5L0.15 0.86C-0.05 0.66 -0.05 0.35 0.15 0.15C0.35 -0.05 0.66 -0.05 0.86 0.15L5.35 4.66C5.55 4.86 5.55 5.17 5.35 5.37L0.85 9.86C0.75 9.96 0.62 10.01 0.5 10.01Z" fill="currentColor"/>
                            </svg>
                        </div>
                    </div>
                </li>
                {/each}

            </ul>

            <button class="close-action-popup fs-90" on:click={() => closeHandler() }>
                {$t('actions.popupCloseButton')}
            </button>
        </div>
    </div>

</div>

{/if}
